import { Component, OnInit } from '@angular/core';
import { ExamService } from 'src/app/services/Exam/exam.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';

@Component({
  selector: 'app-perssonal-skill-activity-map',
  templateUrl: './perssonal-skill-activity-map.component.html',
  styleUrls: ['./perssonal-skill-activity-map.component.css']
})
export class PerssonalSkillActivityMapComponent implements OnInit {

  constructor(private examService:ExamService,private lookupService: LookupService, private globalHelper: GlobalHelper,     private spinnerService: Ng4LoadingSpinnerService) { }
 
  PerssonalSkillActivityMapModel = {
    ClassID: 0,

};

SavePerssonalSkillActivityMap  () {
    
    this.examService.SavePerssonalSkillActivityMap(this.PerssonalSkillActivityMapModel.ClassID, JSON.stringify(this.PerssonalSkillActivityList)).subscribe( (response)=> {
        
        this.globalHelper.CheckActionStatus(response);
    });
};
ClassList:any;
GetClass  () {
    this.lookupService.GetLookupsList('ClassExamFormat1Grading', '').subscribe( (data)=> {
        this.ClassList = data.LookupItems;
    });
};

PerssonalSkillActivityList:any;
SetMultipleValue  (item) {

    for (var i = 0; i < this.PerssonalSkillActivityList.length; i++) {
        if (this.PerssonalSkillActivityList[i].PersonalSkillID == item.PersonalSkillID) {
            this.PerssonalSkillActivityList[i].AssDisplayOrder = item.AssDisplayOrder;
        }
    }
}


GetPerssonalSkillActivityMap  () {
    this.spinnerService.show()
    
    this.examService.GetPerssonalSkillActivityMap(this.PerssonalSkillActivityMapModel.ClassID).subscribe( (response)=> {
        this.PerssonalSkillActivityList = response.PerssonalSkillActivityList;
        this.spinnerService.hide()
    
        this.globalHelper.CheckActionStatus(response);
    });
};



  ngOnInit() {
    this.GetClass();
  }

}
